export default function (errorInfo) {
  console.warn('has error info', errorInfo)

  let className = 'vant_dialog'
  if (window.browserVersion.mobile) {
    className = 'vant_dialog_m'
  }
  window.meaasgeAlert(errorInfo.intro)
  window.AppRoot.loading = false
  // window.vant.Dialog.alert({
  //   // message: errorInfo.intro + ' [Err: ' +errorInfo.code + ']',
  //   message: errorInfo.intro,
  //   confirmButtonText: 'OK',
  //   confirmButtonColor: '#009265',
  //   className: className,
  // }).then(() => {
  //   window.AppRoot.loading = false
  // })
}
